export const LOCKED = 'BLOQUEADO';
export const UNLOCKED = 'NO BLOQUEADO';
